import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';
import Image from '../../../Core/Image';

import { PromoBannerWrapper, Content, Heading, ImageWrapper } from './styles';

const PromoImageBanner = ({ data }) => {
  if (!data) return null;

  const { heading, mediaimageDam, backgroundColor } = data;

  const title = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Heading txtColor={backgroundColor}>{children}</Heading>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <Heading txtColor={backgroundColor}>{children}</Heading>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Heading txtColor={backgroundColor}>{children}</Heading>
      ),
    },
  };

  return (
    <PromoBannerWrapper bgColor={backgroundColor}>
      <Content>
        <RichText document={heading} options={title} />
      </Content>
      <ImageWrapper>
        <Image src={mediaimageDam[0]} alt={mediaimageDam[0].altText || ''} />
      </ImageWrapper>
    </PromoBannerWrapper>
  );
};

PromoImageBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default PromoImageBanner;
